import { render, staticRenderFns } from "./QuotationBrush.vue?vue&type=template&id=6501d478&scoped=true&"
import script from "./QuotationBrush.vue?vue&type=script&lang=js&"
export * from "./QuotationBrush.vue?vue&type=script&lang=js&"
import style0 from "./QuotationBrush.vue?vue&type=style&index=0&id=6501d478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6501d478",
  null
  
)

export default component.exports